import { request } from "@/service/request.js";

// 散客票批量发起退票
export function scatteredGetRefundTicket(options) {
  return request.call(this, {
      url: "openapi/web/individual/multiRefundTicket",
      method: 'POST',
      data:options
  });
}

// 导游票批量发起退票
export function groupRefundTicket(options) {
  return request.call(this, {
      url: "openapi/web/group/multiRefundTicket",
      method: 'POST',
      data:options
  });
}

// 免费票批量发起退票
export function freeRefundTicket(options) {
  return request.call(this, {
      url: "openapi/web/free/multiRefundTicket",
      method: 'POST',
      data:options
  });
}

